// EXCLUSIVE_STRATEGY
const containsAnyFeature = (features, shingle, keys) => {
  return !keys.length || keys.map(key => features.find(f => f?.key === key)).some(f => f?.isInShingleOrColor(shingle));
};

// MULTISELECT_STRATEGY
const containsEveryFeature = (features, shingle, keys) => {
  return !keys.length || keys.map(key => features.find(f => f?.key === key)).every(f => f?.isInShingleOrColor(shingle));
};

const selectShingleColors = (features, shingle_colors, given_colors, given_features) => {
  let shingle_color_features = given_features.map(gf => features.find(f => f?.key === gf)).filter(f => f?.shingleColorFeature);

  const colorFilter = shingle_color => shingle_color.colors.some(color => given_colors.indexOf(color) >= 0)

  if(shingle_color_features.length === 0)
    return given_colors.length === 0 && shingle_colors || shingle_colors.filter(colorFilter)

  return shingle_colors.filter(sc => shingle_color_features.some( f => f.isIncludedIn(sc)) && (!given_colors.length || sc.colors.some(color => given_colors.indexOf(color) >= 0)))
}

const filter = (allFeatures, allwarranties, allwindResistances, allimpactResistances) => (shingles, filters) => {
  const { colors, names, prices, features, windResistances, impactResistances, warranties } = filters;

  return shingles
    .map(shingle => {
      return {
        ...shingle,
        shingle_colors: selectShingleColors(allFeatures, shingle.shingle_colors, colors, features).sort(sc => !sc.newcolor)
      };
    })
    .filter(shingle => {
      if (!shingle.shingle_colors.length) {
        return false;
      }

      if (names.length && names.indexOf(shingle.proper_name) < 0) {
        return false;
      }

      if (prices.length && prices.indexOf(shingle.price_uid) < 0) {
        return false;
      }

      if ((allwindResistances != undefined) && !containsAnyFeature(allwindResistances, shingle, windResistances)) {
        return false
      }

      if ((allimpactResistances != undefined) && !containsAnyFeature(allimpactResistances, shingle, impactResistances)) {
        return false
      }

      if ((allwarranties != undefined) && !containsAnyFeature(allwarranties, shingle, warranties)) {
        return false
      }

      if (!containsEveryFeature(allFeatures, shingle, features)) {
        return false
      }

      return true;
    });
};

export default filter;
